import { HomeConfig } from '@tenants/types/tenant';
import { CountryCodeList } from 'types/countries';

export function createHomeConfig(
  country: CountryCodeList.CANADA | CountryCodeList.UNITED_STATES = CountryCodeList.CANADA
): HomeConfig {
  const internalLinksCA = [
    {
      title: 'Popular Cities',
      links: [
        {
          label: 'Toronto Real Estate',
          link: '/toronto-on-real-estate',
        },
        {
          label: 'Vancouver Real Estate',
          link: '/vancouver-bc-real-estate',
        },
        {
          label: 'Calgary Real Estate',
          link: '/calgary-ab-real-estate',
        },
        {
          label: 'Edmonton Real Estate',
          link: '/edmonton-ab-real-estate',
        },
        {
          label: 'Ottawa Real Estate',
          link: '/ottawa-on-real-estate',
        },
        {
          label: 'Mississauga Real Estate',
          link: '/mississauga-on-real-estate',
        },
        {
          label: 'Winnipeg Real Estate',
          link: '/winnipeg-mb-real-estate',
        },
        {
          label: 'Halifax Real Estate',
          link: '/halifax-ns-real-estate',
        },
        {
          label: 'Moncton Real Estate',
          link: '/moncton-nb-real-estate',
        },
        {
          label: 'Burnaby Real Estate',
          link: '/burnaby-bc-real-estate',
        },
        {
          label: 'Hamilton Real Estate',
          link: '/hamilton-on-real-estate',
        },
        {
          label: 'Surrey Real Estate',
          link: '/surrey-bc-real-estate',
        },
        {
          label: 'Brampton Real Estate',
          link: '/brampton-on-real-estate',
        },
        {
          label: 'Victoria Real Estate',
          link: '/victoria-bc-real-estate',
        },
        {
          label: 'Saskatoon Real Estate',
          link: '/saskatoon-sk-real-estate',
        },
        {
          label: 'Regina Real Estate',
          link: '/regina-sk-real-estate',
        },
        {
          label: 'Kelowna Real Estate',
          link: '/kelowna-bc-real-estate',
        },
        {
          label: 'London Real Estate',
          link: '/london-on-real-estate',
        },
        {
          label: "St. John's Real Estate",
          link: '/st-johns-nl-real-estate',
        },
        {
          label: 'Barrie Real Estate',
          link: '/barrie-on-real-estate',
        },
        {
          label: 'Fredericton Real Estate',
          link: '/fredericton-nb-real-estate',
        },
      ],
    },
    {
      title: 'Condos for Sale in Canada',
      links: [
        {
          label: 'Toronto Condos for Sale',
          link: '/toronto-on-real-estate/condos',
        },
        {
          label: 'Vancouver Condos for Sale',
          link: '/vancouver-bc-real-estate/condos',
        },
        {
          label: 'Calgary Condos for Sale',
          link: '/calgary-ab-real-estate/condos',
        },
        {
          label: 'Edmonton Condos for Sale',
          link: '/edmonton-ab-real-estate/condos',
        },
        {
          label: 'Ottawa Condos for Sale',
          link: '/ottawa-on-real-estate/condos',
        },
        {
          label: 'Mississauga Condos for Sale',
          link: '/mississauga-on-real-estate/condos',
        },
        {
          label: 'Brampton Condos for Sale',
          link: '/brampton-on-real-estate/condos',
        },
        {
          label: 'Hamilton Condos for Sale',
          link: '/hamilton-on-real-estate/condos',
        },
        {
          label: 'Surrey Condos for Sale',
          link: '/surrey-bc-real-estate/condos',
        },
        {
          label: 'London Condos for Sale',
          link: '/london-on-real-estate/condos',
        },
        {
          label: 'Winnipeg Condos for Sale',
          link: '/winnipeg-mb-real-estate/condos',
        },
        {
          label: 'Halifax Condos for Sale',
          link: '/halifax-ns-real-estate/condos',
        },
        {
          label: 'Victoria Condos for Sale',
          link: '/victoria-bc-real-estate/condos',
        },
        {
          label: 'Kitchener Condos for Sale',
          link: '/kitchener-on-real-estate/condos',
        },
        {
          label: 'Burnaby Condos for Sale',
          link: '/burnaby-bc-real-estate/condos',
        },
        {
          label: 'Saskatoon Condos for Sale',
          link: '/saskatoon-sk-real-estate/condos',
        },
        {
          label: 'Regina Condos for Sale',
          link: '/regina-sk-real-estate/condos',
        },
        {
          label: 'Barrie Condos for Sale',
          link: '/barrie-on-real-estate/condos',
        },
        {
          label: 'Kelowna Condos for Sale',
          link: '/kelowna-bc-real-estate/condos',
        },
        {
          label: 'Oakville Condos for Sale',
          link: '/oakville-on-real-estate/condos',
        },
      ],
    },
    {
      title: 'Popular Ontario Cities',
      links: [
        {
          label: 'Toronto Homes for Sale',
          link: '/toronto-on-real-estate',
        },
        {
          label: 'Ottawa Homes for Sale',
          link: '/ottawa-on-real-estate',
        },
        {
          label: 'Mississauga Homes for Sale',
          link: '/mississauga-on-real-estate',
        },
        {
          label: 'Brampton Homes for Sale',
          link: '/brampton-on-real-estate',
        },
        {
          label: 'Hamilton Homes for Sale',
          link: '/hamilton-on-real-estate',
        },
        {
          label: 'London Homes for Sale',
          link: '/london-on-real-estate',
        },
        {
          label: 'Vaughan Homes for Sale',
          link: '/vaughan-on-real-estate',
        },
        {
          label: 'Markham Homes for Sale',
          link: '/markham-on-real-estate',
        },
        {
          label: 'Kitchener Homes for Sale',
          link: '/kitchener-on-real-estate',
        },
        {
          label: 'Windsor Homes for Sale',
          link: '/windsor-on-real-estate',
        },
        {
          label: 'Oakville Homes for Sale',
          link: '/oakville-on-real-estate',
        },
        {
          label: 'Burlington Homes for Sale',
          link: '/burlington-on-real-estate',
        },
        {
          label: 'Richmond Hill Homes for Sale',
          link: '/richmond-hill-on-real-estate',
        },
        {
          label: 'Whitby Homes for Sale',
          link: '/whitby-on-real-estate',
        },
        {
          label: 'Ajax Homes for Sale',
          link: '/ajax-on-real-estate',
        },
        {
          label: 'Guelph Homes for Sale',
          link: '/guelph-on-real-estate',
        },
        {
          label: 'Oshawa Homes for Sale',
          link: '/oshawa-on-real-estate',
        },
        {
          label: 'Cambridge Homes for Sale',
          link: '/cambridge-on-real-estate',
        },
        {
          label: 'Barrie Homes for Sale',
          link: '/barrie-on-real-estate',
        },
        {
          label: 'St. Catharines Homes for Sale',
          link: '/st-catharines-on-real-estate',
        },
      ],
    },
    {
      title: 'Popular Real Estate Searches',
      links: [
        {
          label: 'MLS® Listings in Canada',
          link: '/ca-real-estate',
        },
        {
          label: 'Calgary MLS® Listings',
          link: '/calgary-ab-real-estate',
        },
        {
          label: 'Toronto Rentals',
          link: '/toronto-on-real-estate/for-rent',
        },
        {
          label: 'Houses for Sale in Canada',
          link: '/ca-real-estate/houses',
        },
        {
          label: 'First-Time Home Buyer',
          link: 'https://zoocasa.ac-page.com/first-time-buyer-guide',
        },
        {
          label: 'Sold Prices in Canada',
          link: '/ca-real-estate/sold',
        },
        {
          label: 'Real Estate Market Trends',
          link: '/blog/',
        },
        {
          label: 'Vancouver Townhouses for Sale',
          link: '/vancouver-bc-real-estate/townhouses',
        },
        {
          label: 'Calgary Houses for Sale',
          link: '/calgary-ab-real-estate/houses',
        },
        {
          label: 'Ottawa Townhomes for Sale',
          link: '/ottawa-on-real-estate/townhouses',
        },
        {
          label: 'Edmonton Houses for Sale',
          link: '/edmonton-ab-real-estate/houses',
        },
        {
          label: 'Hamilton Townhouses for Sale',
          link: '/hamilton-on-real-estate/townhouses',
        },
        {
          label: 'Pre-Construction Houses in Canada',
          link: '/newhomes',
        },
        {
          label: 'Canada Real Estate',
          link: '/ca-real-estate',
        },
        {
          label: 'New Houses for Sale in Canada',
          link: '/ca-real-estate/houses',
        },
        {
          label: 'Affordable Houses for Sale in Ontario',
          link: '/ontario-real-estate/filter?price-max=800000',
        },
        {
          label: 'Luxury Homes for Sale in Toronto',
          link: '/toronto-on-real-estate/filter?price-min=1500000',
        },
      ],
    },
  ];

  const internalLinksUS = [
    {
      title: 'USA Homes For Sale',
      links: [
        {
          label: 'All USA Real Estate For Sale',
          link: '/us-real-estate',
        },
        {
          label: 'Arizona Real Estate For Sale',
          link: '/arizona-real-estate',
        },
        {
          label: 'Florida Real Estate For Sale',
          link: '/florida-real-estate',
        },
        {
          label: 'Illinois Real Estate For Sale',
          link: '/illinois-real-estate',
        },
        {
          label: 'Michigan Real Estate For Sale',
          link: '/michigan-real-estate',
        },
        {
          label: 'Nevada Real Estate For Sale',
          link: '/nevada-real-estate',
        },
        {
          label: 'New Hampshire Real Estate For Sale',
          link: '/new-hampshire-real-estate',
        },
        {
          label: 'New Jersey Real Estate For Sale',
          link: '/new-jersey-real-estate',
        },
        {
          label: 'New Mexico Real Estate For Sale',
          link: '/new-mexico-real-estate',
        },
        {
          label: 'New York Real Estate For Sale',
          link: '/new-york-real-estate',
        },
        {
          label: 'North Carolina Real Estate For Sale',
          link: '/north-carolina-real-estate',
        },
        {
          label: 'Ohio Real Estate For Sale',
          link: '/ohio-real-estate',
        },
        {
          label: 'Pennsylvania Real Estate For Sale',
          link: '/pennsylvania-real-estate',
        },
        {
          label: 'Rhode Island Real Estate For Sale',
          link: '/rhode-island-real-estate',
        },
        {
          label: 'South Carolina Real Estate For Sale',
          link: '/south-carolina-real-estate',
        },
        {
          label: 'Vermont Real Estate For Sale',
          link: '/vermont-real-estate',
        },
        {
          label: 'Virginia Real Estate For Sale',
          link: '/virginia-real-estate',
        },
        {
          label: 'West Virginia Real Estate For Sale',
          link: '/west-virginia-real-estate',
        },
      ],
    },
    {
      title: 'USA Sold Real Estate',
      links: [
        {
          label: 'All USA Sold Real Estate',
          link: '/us-real-estate/sold',
        },
        {
          label: 'Arizona Sold Real Estate',
          link: '/arizona-real-estate/sold',
        },
        {
          label: 'Florida Sold Real Estate',
          link: '/florida-real-estate/sold',
        },
        {
          label: 'Illinois Sold Real Estate',
          link: '/illinois-real-estate/sold',
        },
        {
          label: 'Michigan Sold Real Estate',
          link: '/michigan-real-estate/sold',
        },
        {
          label: 'Nevada Sold Real Estate',
          link: '/nevada-real-estate/sold',
        },
        {
          label: 'New Hampshire Sold Real Estate',
          link: '/new-hampshire-real-estate/sold',
        },
        {
          label: 'New Jersey Sold Real Estate',
          link: '/new-jersey-real-estate/sold',
        },
        {
          label: 'New Mexico Sold Real Estate',
          link: '/new-mexico-real-estate/sold',
        },
        {
          label: 'New York Sold Real Estate',
          link: '/new-york-real-estate/sold',
        },
        {
          label: 'North Carolina Sold Real Estate',
          link: '/north-carolina-real-estate/sold',
        },
        {
          label: 'Ohio Sold Real Estate',
          link: '/ohio-real-estate/sold',
        },
        {
          label: 'Pennsylvania Sold Real Estate',
          link: '/pennsylvania-real-estate/sold',
        },
        {
          label: 'Rhode Island Sold Real Estate',
          link: '/rhode-island-real-estate/sold',
        },
        {
          label: 'South Carolina Sold Real Estate',
          link: '/south-carolina-real-estate/sold',
        },
        {
          label: 'Vermont Sold Real Estate',
          link: '/vermont-real-estate/sold',
        },
        {
          label: 'Virginia Sold Real Estate',
          link: '/virginia-real-estate/sold',
        },
        {
          label: 'West Virginia Sold Real Estate',
          link: '/west-virginia-real-estate/sold',
        },
      ],
    },
    {
      title: 'Popular USA Rentals',
      links: [
        {
          label: 'All USA Rentals',
          link: '/us-real-estate/for-rent',
        },
        {
          label: 'Arizona Rentals',
          link: '/arizona-real-estate/for-rent',
        },
        {
          label: 'Florida Rentals',
          link: '/florida-real-estate/for-rent',
        },
        {
          label: 'Illinois Rentals',
          link: '/illinois-real-estate/for-rent',
        },
        {
          label: 'Michigan Rentals',
          link: '/michigan-real-estate/for-rent',
        },
        {
          label: 'Nevada Rentals',
          link: '/nevada-real-estate/for-rent',
        },
        {
          label: 'New Hampshire Rentals',
          link: '/new-hampshire-real-estate/for-rent',
        },
        {
          label: 'New Jersey Rentals',
          link: '/new-jersey-real-estate/for-rent',
        },
        {
          label: 'New Mexico Rentals',
          link: '/new-mexico-real-estate/for-rent',
        },
        {
          label: 'New York Rentals',
          link: '/new-york-real-estate/for-rent',
        },
        {
          label: 'North Carolina Rentals',
          link: '/north-carolina-real-estate/for-rent',
        },
        {
          label: 'Ohio Rentals',
          link: '/ohio-real-estate/for-rent',
        },
        {
          label: 'Pennsylvania Rentals',
          link: '/pennsylvania-real-estate/for-rent',
        },
        {
          label: 'Rhode Island Rentals',
          link: '/rhode-island-real-estate/for-rent',
        },
        {
          label: 'South Carolina Rentals',
          link: '/south-carolina-real-estate/for-rent',
        },
        {
          label: 'Vermont Rentals',
          link: '/vermont-real-estate/for-rent',
        },
        {
          label: 'Virginia Rentals',
          link: '/virginia-real-estate/for-rent',
        },
        {
          label: 'West Virginia Rentals',
          link: '/west-virginia-real-estate/for-rent',
        },
      ],
    },
    {
      title: 'Popular USA Cities',
      links: [
        {
          label: 'Albany Real Estate For Sale',
          link: '/albany-ny-real-estate',
        },
        {
          label: 'Albuquergue Real Estate For Sale',
          link: '/albuquerque-nm-real-estate',
        },
        {
          label: 'Charleston Real Estate For Sale',
          link: '/charleston-sc-real-estate',
        },
        {
          label: 'Chicago Real Estate For Sale',
          link: '/chicago-il-real-estate',
        },
        {
          label: 'Cleveland Real Estate For Sale',
          link: '/cleveland-oh-real-estate',
        },
        {
          label: 'Columbus Real Estate For Sale',
          link: '/columbus-oh-real-estate',
        },
        {
          label: 'Fort Lauderdale Real Estate For Sale',
          link: '/fort-lauderdale-fl-real-estate',
        },
        {
          label: 'Fort Myers Real Estate For Sale',
          link: '/fort-myers-fl-real-estate',
        },
        {
          label: 'Gainsville Real Estate For Sale',
          link: '/gainesville-fl-real-estate',
        },
        {
          label: 'Las Vegas Real Estate For Sale',
          link: '/las-vegas-nv-real-estate',
        },
        {
          label: 'Miami Real Estate For Sale',
          link: '/miami-fl-real-estate',
        },
        {
          label: 'New Brunswick Real Estate For Sale',
          link: '/new-brunswick-nj-real-estate',
        },
        {
          label: 'Orlando Real Estate For Sale',
          link: '/orlando-fl-real-estate',
        },
        {
          label: 'Phoenix Real Estate For Sale',
          link: '/phoenix-az-real-estate',
        },
        {
          label: 'Providence Real Estate For Sale',
          link: '/providence-ri-real-estate',
        },
        {
          label: 'Tampa Real Estate For Sale',
          link: '/tampa-fl-real-estate',
        },
      ],
    },
    {
      title: 'Popular USA Searches',
      description: 'Data containing cities/states with highest agent count',
      links: [
        {
          label: 'California Real Estate For Sale',
          link: '/california-real-estate',
        },
        {
          label: 'Texas Real Estate For Sale',
          link: '/texas-real-estate',
        },
        {
          label: 'Florida Real Estate For Sale',
          link: '/florida-real-estate',
        },
        {
          label: 'New York Real Estate For Sale',
          link: '/new-york-real-estate',
        },
        {
          label: 'Pennsylvania Real Estate For Sale',
          link: '/pennsylvania-real-estate',
        },
        {
          label: 'Illinois Real Estate For Sale',
          link: '/illinois-real-estate',
        },
        {
          label: 'New York City, NY Real Estate For Sale',
          link: '/new-york-ny-real-estate',
        },
        {
          label: 'Newark, NJ Real Estate For Sale',
          link: '/newark-nj-real-estate',
        },
        {
          label: 'Los Angeles, CA Real Estate For Sale',
          link: '/los-angeles-ca-real-estate',
        },
        {
          label: 'Chicago, IL Real Estate For Sale',
          link: '/chicago-il-real-estate',
        },
        {
          label: 'Houston, TX Real Estate For Sale',
          link: '/houston-tx-real-estate',
        },
        {
          label: 'Washington, DC Real Estate For Sale',
          link: '/washington-dc-real-estate',
        },
      ],
    },
  ];

  return {
    internalLinks: country === CountryCodeList.CANADA ? internalLinksCA : internalLinksUS,
  };
}
